//     __                       _
//    / /___ _____  __  _______(_)___  ___  _____
//   / / __ `/_  / / / / / ___/ /_  / / _ \/ ___/
//  / / /_/ / / /_/ /_/ (__  ) / / /_/  __(__  )
// /_/\__,_/ /___/\__, /____/_/ /___/\___/____/
//               /____/

import { setupProjectParallax } from './parallax';
import { setupSlider } from './slider';

const setupLazySizes = () => {
  // console.log( '{ setupLazysizes }' );

  // --------------------------------------------------------------------------------
  //
  // Lazysizes settings
  //
  // --------------------------------------------------------------------------------
  // window.lazySizesConfig = window.lazySizesConfig || {};

  // Set loading class
  // window.lazySizesConfig.loadingClass = 'loading';

  // Set distance from visible area that element lazyloads
  // lazySizesConfig.expand = 0;

  document.addEventListener('lazybeforeunveil', e => {
    // const classes = e.target.attributes.class.value;
    // console.log( 'lazybeforeunveil: e.target: %o', e.target );
    // console.log( 'classes: %o', classes );

    // --------------------------------------------------------------------------------
    //
    // Parallax Project Images - Home & Page Headers
    //
    // --------------------------------------------------------------------------------
    if (
      e.target.matches('.home-project__image') ||
      e.target.matches('.header-page__image')
    ) {
      $(e.target).one('load', function() {
        // setup scrollMagic
        setupProjectParallax(e.target.parentNode.parentNode);
      });
    }

    // --------------------------------------------------------------------------------
    //
    // Slider / Team Slider
    //
    // --------------------------------------------------------------------------------
    if (
      e.target.matches('.slide__image') ||
      e.target.matches('.card--team__slide')
    ) {
      $(e.target).one('load', function() {
        if ($(e.target.parentNode.parentNode).hasClass('loading')) {
          $(e.target.parentNode.parentNode).removeClass('loading');

          // setup slider
          setupSlider(e.target.parentNode.parentNode);
        }
      });
    }

    // ----------------------------------------------------------------------------
    // Video slides
    // ----------------------------------------------------------------------------
    if (e.target.matches('.aspect--slide')) {
      if ($(e.target.parentNode.parentNode).hasClass('loading')) {
        $(e.target.parentNode.parentNode).removeClass('loading');

        // setup slider
        setupSlider(e.target.parentNode.parentNode);
      }
    }

    // --------------------------------------------------------------------------------
    //
    // Team Slider
    //
    // --------------------------------------------------------------------------------
    // if (e.target.matches('.card--team__slide') || ) {
    //   $(e.target).one('load', function() {
    //     if ($(e.target.parentNode.parentNode).hasClass('loading')) {
    //       $(e.target.parentNode.parentNode).removeClass('loading');

    //       // setup slider
    //       setupSlider(e.target.parentNode.parentNode);
    //     }
    //   });
    // }
  });
};

export { setupLazySizes };



// WEBPACK FOOTER //
// ./scripts/modules/lazysizes.js